import { combineEpics } from 'redux-observable';
import { fetchAllDispatchRoutes } from '@/store/epics/staff/dispatch-routes/fetch-all-dispatch-routes.epic';
import { moveStopAndDispatchRoutes } from '@/store/epics/staff/dispatch-routes/move-stop-fetch-dispatch-routes.epic';
import { changeDriver } from './change-driver.epic';
import { changeStopTime } from './change-stop-time.epic';

export const combinedDispatchRouteEpics = combineEpics(fetchAllDispatchRoutes, moveStopAndDispatchRoutes, changeDriver, changeStopTime);
